import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getFeatures } from '@/api/features';
import { useFeaturesStore } from '@/stores/features';

/**
 * Загружает feature flags с бэкенда и синхронизирует в Zustand-стор.
 * Кеширует на 5 минут — при каждом маунте не дёргает сервер.
 */
export function useFeatures() {
	const setFlag = useFeaturesStore((s) => s.setFlag);

	const query = useQuery({
		queryKey: ['features'],
		queryFn: getFeatures,
		staleTime: 5 * 60 * 1000,
	});

	// Синхронизация серверных флагов в Zustand-стор. Ответ без поля -- функция выключена:
	// после ответа у флага есть значение, и страницы за ним не ждут бесконечно
	useEffect(() => {
		if (query.data) {
			setFlag('kubehound', query.data.kubehound === true);
		}
	}, [query.data, setFlag]);

	return query;
}
